import {
  ActionIcon,
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  GridCol,
  Group,
  Loader,
  LoadingOverlay,
  Menu,
  MultiSelect,
  SelectProps,
  TextInput,
  Title,
  Tooltip,
  rem,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import {
  useDebouncedCallback,
  useDisclosure,
  useHotkeys,
} from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconArrowLeft,
  IconBarcode,
  IconBrandMedium,
  IconCalendar,
  IconCaretDown,
  IconCheck,
  IconEye,
  IconFileExport,
  IconFileUpload,
  IconHandStop,
  IconMapRoute,
  IconReload,
  IconRocket,
  IconSearch,
  IconStatusChange,
  IconTrash,
  IconUserCheck,
  IconX,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_RowSelectionState,
  MRT_SortingState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router";
import {
  _timerDelayClick,
  KeySearchTestingTechnique,
  repositoryDelivery,
  repositoryMdm,
} from "../../_base/_const/_constVar";
import _breadcrumb from "../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { getValueById } from "../../_base/helper/FunctionHelper";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../common/FormatDate/FormatDate";
import InputSearch from "../../common/InputSearch/InputSearch";
import { _localization } from "../../config/location";
import { green, orange, red, sky_blue } from "../../const/variables";
import { MessageResponse } from "../../model/MessageResponse";
import { TblDmEmployeeModel } from "../../model/TblDmEmployeeModel";
import { TblTestingTechniqueHeaderGetList } from "../../model/TblTestingTechniqueHeader";
import TableDetail from "./TableDetail";
import { BASE_API_DELIVERY } from "../../config";
import dayjs from "dayjs";
import { getMasterOrgSelect } from "../../service/getSelectApi";
import { IconPlus } from "@tabler/icons-react";

function getColorStatus(text: any) {
  switch (text) {
    case "TAO_MOI":
      return sky_blue.base;
    case "PHAN_CONG":
      return orange.base;
    // case "TIEP_NHAN":
    //   return "#ffab09";
    case "DANG_KIEM_TRA":
      return "#d9d02f";
    // case "DA_KIEM_TRA":
    //   return "green";
    case "TEST_MOT_PHAN":
      return "#ffcc00";
    case "TEST_LOI":
      return "red";
    case "TEST_OK":
      return "#17a2b8";
    case "HUY_PHAN_CONG":
      return "red";
    case "":
      return "green";
    // case "THANH_CONG":
    //   return green.light;
    // case "THAT_BAI":
    //   return red.base;
    default:
      return sky_blue.base;
  }
}

const TestingTechnique = () => {
  const navigate = useNavigate();
  // Reference data from another table
  const [dataTblLocation, setDataTblLocation] = useState<ComboboxItem[]>([]);

  //data and fetching state
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<TblTestingTechniqueHeaderGetList[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [dataEmployee, setDataEmployee] = useState<TblDmEmployeeModel[]>([]);
  const [dataBranchSelect, setDataBranchSelect] = useState<ComboboxItem[]>([]);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  //table state
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 20 });
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [visible, { toggle, open, close }] = useDisclosure(false);
  //count
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCounting, setIsCounting] = useState(false);
  const [isCallFirst, setIsCallFirst] = useState<boolean>(false);
  const dataStatusOption = [
    { value: "TAO_MOI", label: "Tạo mới" },
    { value: "PHAN_CONG", label: "Phân công" },
    // { value: "TIEP_NHAN", label: "Tiếp nhận" },
    { value: "DANG_KIEM_TRA", label: "Đang kiểm tra" },
    // { value: "DA_KIEM_TRA", label: "Đã kiểm tra" },
    { value: "TEST_MOT_PHAN", label: "Test một phần" },
    { value: "TEST_LOI", label: "Test lỗi" },
    { value: "TEST_OK", label: "Test ok" },
    { value: "HUY_PHAN_CONG", label: "Hủy phân công" },
    // { value: "THANH_CONG", label: "Thành công" },
    // { value: "THAT_BAI", label: "Thất bại" },
  ];
  const dataSourceStatus = [
    { value: "DON_HANG_TAM", label: "Đơn hàng tạm" },
    { value: "DON_HANG_HOAN_THANH", label: "Đơn hàng hoàn thành" },
    {
      value: "THANH_TOAN_CHUA_HOAN_THANH",
      label: "Thanh toán chưa hoàn thành",
    },
    {
      value: "pending",
      label: "Chưa giải quyết",
    },
    {
      value: "DON_HANG_BAN_TAI_SHOP",
      label: "Đơn hàng bán tại shop",
    },
    {
      value: "KHO_XUAT_HANG",
      label: "Kho xuất hàng",
    },
    {
      value: "KY_THUAT_TIEP_NHAN",
      label: "Kỹ thuật tiếp nhận",
    },
    {
      value: "KY_THUAT_XONG",
      label: "Kỹ thuật xong",
    },
    {
      value: "GHND_TIEP_NHAN",
      label: "GHND tiếp nhận",
    },
    {
      value: "LOCK",
      label: "Phiếu khóa",
    },
    {
      value: "CANCLE",
      label: "Phiếu huỷ",
    },
    {
      value: "OPEN",
      label: "Đang nhập",
    },
  ];

  const sourceTypeData = [
    { label: "Đơn Hàng", value: "DON_HANG" },
    { label: "Nhập Kho Bảo Hành NCC", value: "NHAP_KHO_BH_NCC" },
    { label: "Nhập Kho Bảo Hành", value: "NHAP_KHO_BH" },
    { label: "Chuyển Đổi Dữ Liệu", value: "CHUYEN_DOI_DU_LIEU" },
    { label: "Lắp ráp", value: "LAP_RAP" },
    { label: "Khác", value: "KHAC" },
  ];

  const [testDifficultys, setTestDifficultys] = useState<any[]>([]);

  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";

  const _searchJson = sessionStorage.getItem(KeySearchTestingTechnique)
    ? JSON.parse(sessionStorage.getItem(KeySearchTestingTechnique) ?? "")
    : null;

  const innitStateSearch = useMemo(
    () => ({
      keySearch: _searchJson && checkedPinSearch ? _searchJson.keySearch : "",
      fromDate:
        _searchJson && checkedPinSearch
          ? _searchJson.fromDate
          : new Date(
              new Date(
                new Date().setMonth(new Date().getMonth() - 1),
              ).getTime() +
                7 * 60 * 60 * 1000,
            )?.toISOString(),
      endDate:
        _searchJson && checkedPinSearch
          ? _searchJson.endDate
          : new Date(new Date().getTime() + 7 * 60 * 60 * 1000).toISOString(),
      sourceType: _searchJson && checkedPinSearch ? _searchJson.sourceType : [],
      status: _searchJson && checkedPinSearch ? _searchJson.status : [],
      serial: _searchJson && checkedPinSearch ? _searchJson.serial : "",
      branch: _searchJson && checkedPinSearch ? _searchJson.branch : [],
    }),
    [_searchJson],
  );
  const [search, setSearch] = useState({
    ...innitStateSearch,
  });

  const [recordSelected, setRecordSelected] = useState<any[]>([]);

  const [refreshKeySearch, setRefreshKeySearch] = useState<any>({});

  const columns = React.useMemo<
    MRT_ColumnDef<TblTestingTechniqueHeaderGetList>[]
  >(
    () => [
      {
        accessorKey: "code",
        header: "Mã kiểm tra",
        Cell: ({ renderedCellValue, row }) =>
          String(row.original.shippingPriority) === "1" ? (
            <Tooltip label="Xem chi tiết">
              <Badge
                radius="sm"
                leftSection={<IconRocket size={12} />}
                size="lg"
                style={{ cursor: "pointer" }}
                color="red"
                onDoubleClick={() =>
                  detailData(row.original.id, row.original.sourceType, 1)
                }
              >
                {renderedCellValue === null ? null : renderedCellValue}
              </Badge>
            </Tooltip>
          ) : (
            <Tooltip label="Xem chi tiết">
              <Badge
                radius="sm"
                variant="dot"
                size="lg"
                style={{ cursor: "pointer" }}
                color={renderedCellValue === null ? "red" : green.base}
                onDoubleClick={() =>
                  detailData(row.original.id, row.original.sourceType, 1)
                }
              >
                {renderedCellValue === null ? null : renderedCellValue}
              </Badge>
            </Tooltip>
          ),
      },
      {
        accessorKey: "testDifficulty",
        header: "Mức độ test của phiếu",
        size: 200,
        Cell: ({ renderedCellValue }) => (
          <Badge variant="default" color="blue" radius="sm">
            {getValueById(
              String(renderedCellValue || ""),
              testDifficultys,
              "label",
            ) ||
              renderedCellValue ||
              "Chưa test"}
          </Badge>
        ),
      },
      {
        accessorKey: "sourceStatus",
        header: "Trạng thái số chứng từ",
        size: 225,
        Cell: ({ row }) => {
          const orderType = row.original.sourceStatus;
          let badgeColor;
          switch (orderType) {
            case "DON_HANG_TAM":
              badgeColor = "cyan";
              break;
            case "DON_HANG_HOAN_THANH":
              badgeColor = "green";
              break;
            case "THANH_TOAN_CHUA_HOAN_THANH":
              badgeColor = "red";
              break;
            case "pending":
              badgeColor = "yellow";
              break;
            case "DON_HANG_BAN_TAI_SHOP":
              badgeColor = "green";
              break;
            case "KHO_XUAT_HANG":
              badgeColor = sky_blue.medium;
              break;
            case "KY_THUAT_TIEP_NHAN":
              badgeColor = "blue";
              break;
            case "KY_THUAT_XONG":
              badgeColor = "green";
              break;
            case "LOCK":
              badgeColor = "gray";
              break;
            case "CANCLE":
              badgeColor = "red";
              break;
            case "OPEN":
              badgeColor = "gray";
              break;
            case null:
              badgeColor = "black";
              break;
            default:
              badgeColor = "lime";
          }
          return (
            <Badge color={badgeColor} fs={"12,5px"} fw={"bold"} radius="sm">
              {row.original.sourceStatus !== null
                ? getValueById(
                    row.original.sourceStatus,
                    dataSourceStatus,
                    "label",
                  )
                : "Không xác định"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "sourceCode",
        header: "Số chứng từ gốc",
        size: 200,
        Cell: ({ renderedCellValue }) => (
          <Badge
            radius="sm"
            variant="dot"
            size="lg"
            color={renderedCellValue === null ? "red" : green.base}
          >
            {renderedCellValue === null ? "Không xác định" : renderedCellValue}
          </Badge>
        ),
      },
      {
        accessorKey: "sourceType",
        header: "Nguồn chứng từ",
        size: 250,
        Cell: ({ renderedCellValue }) => {
          let displayText;
          let badgeColor;
          switch (renderedCellValue) {
            case "DON_HANG":
              displayText = "Đơn hàng";
              badgeColor = "cyan";
              break;
            case "NHAP_KHO_BH_NCC":
              displayText = "Nhập kho bảo hành NCC";
              badgeColor = "teal";
              break;
            case "NHAP_KHO_BH":
              displayText = "Nhập kho bảo hành";
              badgeColor = "orange";
              break;
            case "CHUYEN_DOI_DU_LIEU":
              displayText = "Chuyển đổi dữ liệu";
              badgeColor = "blue";
              break;
            case "LAP_RAP":
              displayText = "Lắp ráp";
              badgeColor = "green";
              break;
            case "KHAC":
              displayText = "Khác";
              badgeColor = "#748DAE";
              break;
            default:
              displayText = "";
          }
          return (
            <>
              <Badge color={badgeColor}>{displayText}</Badge>
            </>
          );
        },
      },
      {
        accessorKey: "sourceDate",
        header: "Ngày lập số chứng từ",
        size: 200,
        Cell: ({ renderedCellValue }) => (
          <>
            {renderedCellValue &&
              formatDateTransfer(renderedCellValue as string)}
          </>
        ),
      },
      {
        accessorKey: "createDate",
        header: "Ngày lập",
        Cell: ({ renderedCellValue }) => (
          <>
            {renderedCellValue &&
              formatDateTransfer(renderedCellValue as string)}
          </>
        ),
      },
      {
        accessorKey: "receptionTime",
        header: "Ngày tiếp nhận",
        Cell: ({ renderedCellValue }) => (
          <>
            {renderedCellValue &&
              formatDateTransfer(renderedCellValue as string)}
          </>
        ),
      },
      {
        accessorKey: "responsibleEmployee",
        header: "Người tiếp nhận",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "completionTime",
        header: "Thời gian hoàn thành",
        size: 200,
        Cell: ({ renderedCellValue }) => (
          <>
            {renderedCellValue &&
              formatDateTransfer(renderedCellValue as string)}
          </>
        ),
      },
      {
        accessorKey: "branchName",
        header: "Chi nhánh",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "subInvName",
        header: "Kho",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "actribute4",
        header: "Bộ phận giao hàng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "customerName",
        header: "Tên khách hàng",
      },
      {
        accessorKey: "customerTelephone",
        header: "SĐT",
      },

      {
        accessorKey: "description",
        header: "Ghi chú",
      },
      {
        accessorKey: "actribute2",
        header: "Ghi chú (Nội bộ)",
      },
      {
        accessorKey: "testingStatus",
        header: "Trạng thái KT",
        Cell: ({ row }) => (
          <>
            <Badge
              color={getColorStatus(row.original.testingStatus)}
              radius={"sm"}
            >
              {getValueById(
                row.original.testingStatus?.toString() ?? "",
                dataStatusOption,
                "label",
              )}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        size: 180,
        enableResizing: false,
        Cell: ({ row }) => {
          const isDisabled = !(
            row.original.testingStatus === "DANG_KIEM_TRA" ||
            row.original.testingStatus === "TEST_MOT_PHAN"
          );
          return (
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <Tooltip label="Chi tiết">
                <ActionIcon
                  variant="light"
                  aria-label="Settings"
                  color="cyan"
                  onClick={async () => {
                    detailData(row.original.id, row.original.sourceType, 1);
                  }}
                >
                  <IconEye size={20} stroke={1.5} />
                </ActionIcon>
              </Tooltip>

              <Tooltip label="Phân công">
                <ActionIcon
                  variant="light"
                  aria-label="Settings"
                  color="violet"
                  disabled={
                    row.original.testingStatus !== "TAO_MOI" &&
                    row.original.testingStatus !== "HUY_PHAN_CONG"
                  }
                  onClick={async () => {
                    assignEmployee(row.original.id, row.original.sourceType);
                  }}
                >
                  <IconHandStop size={20} stroke={1.5} />
                </ActionIcon>
              </Tooltip>

              <Tooltip label="Cập nhật kiểm tra">
                <ActionIcon
                  variant="light"
                  aria-label="Settings"
                  color="teal"
                  disabled={isDisabled}
                  onClick={async () => {
                    updateTesting(
                      row.original.id,
                      row.original.sourceType,
                      row.original.testingStatus,
                      0,
                    );
                  }}
                >
                  <IconReload size={20} stroke={1.5} />
                </ActionIcon>
              </Tooltip>
              <Tooltip label="Trưởng phòng KTBH cập nhật">
                <ActionIcon
                  variant="light"
                  aria-label="Settings"
                  color="#007bff"
                  disabled={
                    row.original.testingStatus !== "TEST_OK" &&
                    row.original.testingStatus !== "TEST_LOI"
                  }
                  onClick={async () => {
                    updateTesting(
                      row.original.id,
                      row.original.sourceType,
                      row.original.testingStatus,
                      2,
                    );
                  }}
                >
                  <IconUserCheck size={20} stroke={1.5} />
                </ActionIcon>
              </Tooltip>
            </Box>
          );
        },
      },
    ],
    [
      dataTblLocation,
      dataEmployee,
      dataStatusOption,
      dataSourceStatus,
      testDifficultys,
    ],
  );

  const startCountdown = () => {
    if (!isCounting) {
      setTimeLeft(_timerDelayClick);
      setIsCounting(true);
    }
  };

  const handleChangeSearchValue = useDebouncedCallback(
    (value: string | string[], key: string) => {
      setSearch((prevData) => ({ ...prevData, [key]: value }));
    },
    500,
  );

  const optionTestingStatus: Record<
    | "Tạo mới"
    | "Phân công"
    | "Đang kiểm tra"
    | "Test một phần"
    | "Test lỗi"
    | "Test ok"
    | "Hủy phân công",
    string
  > = {
    "Tạo mới": "#3B9BDD",
    "Phân công": "#FD8622",
    "Đang kiểm tra": "#d9d02f",
    "Test một phần": "#ffcc00",
    "Test lỗi": "red",
    "Test ok": "#17a2b8",
    "Hủy phân công": red.dark,
  };

  const renderSelectOptionTestingStatus: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionTestingStatus[
            option.label as
              | "Tạo mới"
              | "Phân công"
              | "Đang kiểm tra"
              | "Test một phần"
              | "Test lỗi"
              | "Test ok"
              | "Hủy phân công"
          ]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const createData = () => {
    // navigate("/warehouse-config/create-warehouse-out-ward");
  };

  const detailData = (
    id: string | number,
    type: string | null,
    isAdmin: number,
  ) => {
    navigate("/testing/detail-testing-technique", {
      state: {
        id: id,
        dataStatusOption: dataStatusOption,
        dataSourceStatus: dataSourceStatus,
        typeSourceType: type,
        isAdmin: isAdmin,
      },
    });
  };

  const assignEmployee = (id: string | number, type: string | null) => {
    navigate("/testing/assign-testing-technique", {
      state: {
        id: id,
        dataStatusOption: dataStatusOption,
        dataSourceStatus: dataSourceStatus,
        typeSourceType: type,
      },
    });
  };

  const updateTesting = (
    id: string | number,
    type: string | null,
    testingStatusBHNCC: any,
    isAdmin: number,
  ) => {
    navigate("/testing/update-testing-technique", {
      state: {
        id: id,
        dataStatusOption: dataStatusOption,
        dataSourceStatus: dataSourceStatus,
        typeSourceType: type,
        testingStatusBHNCC: testingStatusBHNCC,
        isAdmin: isAdmin,
      },
    });
  };

  const handleCancelAssignment = () => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>
            Bạn có muốn hủy phân công KTKT các đơn hàng này ?
          </Title>
        </>
      ),
      size: "400px",
      children: (
        <Box>
          {/* <Text fw={500} size="18px" mt={10}>
            Bạn có muốn hủy phân công KTKT các đơn hàng này ?
          </Text> */}
          <Flex justify={"end"} mt={10} gap={"md"}>
            <Button
              variant="outline"
              leftSection={<IconArrowLeft size={"14px"} />}
              onClick={() => modals.closeAll()}
              color="gray"
            >
              Hủy
            </Button>
            <Button
              variant="outline"
              leftSection={<IconX size={"14px"} />}
              onClick={() => cancelAssign()}
              color="red"
            >
              Xác nhận
            </Button>
          </Flex>
        </Box>
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      classNames: {
        title: "custom-modal-title",
        body: "custom-modal-body",
      },
    });
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;

    if (search.keySearch) {
      url += `&KeySearch=${search.keySearch.trim()}`;
    }
    if (search.fromDate) {
      url += `&FromDate=${search.fromDate}`;
    }
    if (search.endDate) {
      url += `&EndDate=${search.endDate}`;
    }
    if (Array.isArray(search.status) && search.status.length > 0) {
      url += search.status?.map((item) => `&Status=${item}`)?.join("");
    }
    if (Array.isArray(search.sourceType) && search.sourceType.length > 0) {
      url += search.sourceType?.map((item) => `&SourceType=${item}`)?.join("");
    }
    if (search.serial) {
      url += `&Serial=${search.serial}`;
    }
    if (Array.isArray(search.branch) && search.branch.length > 0) {
      url += search.branch?.map((item) => `&BranchIds=${item}`)?.join("");
    }

    try {
      const response = await repositoryDelivery.get(
        `/api/v1/TblTestingTechniqueHeader/get-list-v2${url}`,
      );
      if (response && response.success) {
        let result = response.data;
        setIsLoading(false);
        setData(result || []);
        setIsCallFirst(true);
        // Promise.all([dataLocation()]);
        setRowCount(response.totalCount);
        setSelectIds([]);
        table.resetRowSelection();
      } else setData([]);
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(KeySearchTestingTechnique, JSON.stringify(search));
    }
    startCountdown();
  };

  const handleExport = async () => {
    open();
    try {
      let url = `/api/v1/TblTestingTechniqueHeader/export-testing-technique-headers?Skip=${
        pagination?.pageIndex * pagination?.pageSize
      }&Take=${pagination.pageSize}`;

      if (search.keySearch) {
        url += `&KeySearch=${search.keySearch}`;
      }
      if (search.fromDate) {
        url += `&FromDate=${search.fromDate}`;
      }
      if (search.endDate) {
        url += `&EndDate=${search.endDate}`;
      }
      if (Array.isArray(search.status) && search.status.length > 0) {
        url += search.status?.map((item) => `&Status=${item}`)?.join("");
      }
      if (Array.isArray(search.sourceType) && search.sourceType.length > 0) {
        url += search.sourceType
          ?.map((item) => `&SourceType=${item}`)
          ?.join("");
      }
      if (search.serial) {
        url += `&Serial=${search.serial}`;
      }
      if (Array.isArray(search.branch) && search.branch.length > 0) {
        url += search.branch?.map((item) => `&BranchIds=${item}`)?.join("");
      }

      const _url = BASE_API_DELIVERY + url;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        NotificationExtension.Success("Export Excel thành công !");
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename = "Danh_sach_Ky_thuat_kiem_tra.xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const cancelAssign = async () => {
    const req = await repositoryDelivery.post<MessageResponse<any>>(
      "/api/v1/TblTestingTechniqueHeader/cancel-assign",
      { ids: selectIds },
    );

    if (req && req?.success) {
      NotificationExtension.Success("Hủy phân công KTKT thành công !");
      setTimeout(() => {
        modals.closeAll();
        setDeleteViewStatus(!deleteViewStatus);
      }, 1500);
    }
  };

  const fetchDataBranch = async () => {
    const res = await getMasterOrgSelect();

    if (res) {
      const data = res
        ?.filter((item) => item.text && item.value)
        ?.map((item) => ({
          label: item.text?.toString(),
          value: item.value?.toString(),
        }));
      setDataBranchSelect(data);
    }
  };

  const fetchDataTestDifficultys = async () => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      "/api/v1/TechnicalTestLevel/get-list?Skip=0&Take=100",
    );

    if (res && res.success) {
      const data = res.data;
      setTestDifficultys(
        data
          ?.filter((i: any) => i.name && i.code)
          ?.map((i: any) => ({
            label: String(i.name),
            value: String(i.code),
          })),
      );
    }
  };

  useEffect(() => {
    fetchDataTestDifficultys();
  }, []);

  useEffect(() => {
    // fetchEmployee();

    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (155 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      const dataSelected = data.filter((row) =>
        valuesList.includes(row?.id.toString()),
      );
      setRecordSelected(dataSelected);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;
    if (isCounting && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsCounting(false);
    }
    return () => clearInterval(timer);
  }, [isCounting, timeLeft]);

  useHotkeys([
    [
      "F11",
      () => {
        createData();
      },
    ],
  ]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    positionToolbarAlertBanner: "bottom",
    enableTopToolbar: false,

    renderDetailPanel: ({ row }) => {
      return (
        <>
          <TableDetail
            idDetail={row.original.id}
            typeSourceType={row.original.sourceType ?? ""}
          />
        </>
      );
    },

    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "mrt-row-expand", "code"],
        right: ["testingStatus", "action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    onSortingChange: setSorting,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style:
        String(row.original.shippingPriority) === "1"
          ? {
              fontWeight: "500",
              fontSize: "12.5px",
              padding: "5px 12px",
              color: "red",
            }
          : {
              style: {
                fontWeight: "500",
                fontSize: "12.5px",
                padding: "5px 12px",
              },
            },
    }),
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
      sorting,
    },
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: true,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  useEffect(() => {
    fetchData();
  }, [
    sorting,
    pagination.pageIndex,
    pagination.pageSize,
    deleteViewStatus,
    refreshKeySearch,
  ]);
  return (
    <>
      <div
        style={{ border: "1px solid #dee2e6", padding: "5px" }}
        ref={headerRef}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Flex
          gap="md"
          justify={"space-between"}
          align="center"
          direction="row"
          wrap="wrap"
          w={"100%"}
        >
          <_breadcrumb></_breadcrumb>
          <Flex gap="md" align="center" direction="row" wrap="wrap">
            <Button
              leftSection={<IconPlus size={14} />}
              color="teal"
              variant="outline"
              onClick={() => navigate("/testing/create-testing-technique")}
            >
              Tạo mới
            </Button>
            <Button
              leftSection={<IconTrash size={14} />}
              color="red"
              variant="outline"
              onClick={() => {
                handleCancelAssignment();
              }}
              disabled={selectIds.length < 1}
            >
              Hủy phân công
            </Button>

            <Menu shadow="md" width={200}>
              <Menu.Target>
                <Button
                  // size="xs"
                  rightSection={
                    <IconCaretDown
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                >
                  Chức năng
                </Button>
              </Menu.Target>

              <Menu.Dropdown>
                <Menu.Label>Application</Menu.Label>
                <Menu.Item
                  leftSection={
                    <IconFileExport
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                  onClick={handleExport}
                >
                  Export Excel
                </Menu.Item>
                <Tooltip label={"Chức năng đang update"}>
                  <Menu.Item
                    leftSection={
                      <IconFileUpload
                        style={{ width: rem(14), height: rem(14) }}
                      />
                    }
                  >
                    Import Excel
                  </Menu.Item>
                </Tooltip>
              </Menu.Dropdown>
            </Menu>
          </Flex>
        </Flex>

        <Grid mt={10}>
          <GridCol span={{ base: 12, md: 6, lg: 2 }}>
            <InputSearch
              width="100%"
              placeholder="Từ khoá"
              onSearch={fetchData}
              onChange={(value) => {
                handleChangeSearchValue(value, "keySearch");
              }}
              search={search}
              defaultValue={search.keySearch}
            />
          </GridCol>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Từ ngày"
              leftSection={<IconCalendar color="#15aabf" />}
              locale="vi"
              valueFormat="DD/MM/YYYY"
              onChange={(e) => {
                handleChangeSearchValue(
                  formatDateNotTimeZone(e) ?? "",
                  "fromDate",
                );
              }}
              value={search.fromDate ? dayjs(search.fromDate).toDate() : null}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Đến ngày"
              leftSection={<IconCalendar color="#15aabf" />}
              locale="vi"
              valueFormat="DD/MM/YYYY"
              onChange={(e) => {
                handleChangeSearchValue(
                  formatDateNotTimeZone(e) ?? "",
                  "endDate",
                );
              }}
              value={search.endDate ? dayjs(search.endDate).toDate() : null}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Serial"
              leftSection={<IconBarcode color="#15aabf" />}
              onChange={(e) =>
                handleChangeSearchValue(e.currentTarget.value, "serial")
              }
              defaultValue={search.serial}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <GridCol span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder={"Nguồn chứng từ"}
              clearable
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              data={sourceTypeData}
              leftSection={<IconMapRoute color="#15aabf" />}
              onChange={(value) => handleChangeSearchValue(value, "sourceType")}
              value={search.sourceType}
              renderOption={(option) => (
                <Group flex="1" gap="xs">
                  <Badge
                    color={
                      option.option.value === "DON_HANG"
                        ? "cyan"
                        : option.option.value === "NHAP_KHO_BH"
                          ? "orange"
                          : option.option.value === "CHUYEN_DOI_DU_LIEU"
                            ? "blue"
                            : option.option.value === "NHAP_KHO_BH_NCC"
                              ? "teal"
                              : option.option.value === "LAP_RAP"
                                ? "green"
                                : option.option.value === "KHAC"
                                  ? "#748DAE"
                                  : ""
                    }
                    radius="sm"
                    variant="filled"
                  >
                    {option.option.label}
                  </Badge>
                </Group>
              )}
            />
          </GridCol>

          <GridCol span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder={"Trạng thái KT"}
              clearable
              leftSection={<IconStatusChange color="#15aabf" />}
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              data={dataStatusOption}
              onChange={(value) => handleChangeSearchValue(value, "status")}
              value={search.status}
              renderOption={renderSelectOptionTestingStatus}
            />
          </GridCol>
          <GridCol span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Chi nhánh"
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              leftSection={<IconBrandMedium color="#15aabf" />}
              searchable
              clearable
              data={dataBranchSelect}
              value={search.branch}
              onClick={() => {
                if (dataBranchSelect.length === 0) {
                  fetchDataBranch();
                }
              }}
              onChange={(e) => handleChangeSearchValue(e, "branch")}
            />
          </GridCol>
          <GridCol span={{ base: 12, md: 12, lg: 1.05 }}>
            <Button
              leftSection={<IconSearch size={14} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </GridCol>
        </Grid>
      </div>

      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default TestingTechnique;
